export default ngModule => {
  ngModule.controller('ComparatorStep3CtrlNoGateway', function (
      AonApplicationService,
      $log,
      $sce,
      $scope) {

    let ctrl = $scope.$parent.ctrl;
    let currentTypes = ctrl.fieldsets.payment.type.choices;

    $scope.$watch('ctrl.application.payment.type', () => {
      ctrl.application.payment.credit_card.deferred = false;
      for (let t = 0; t < currentTypes.length; ++t) {
        if (currentTypes[t][0] == ctrl.application.payment.type
          && currentTypes[t][1].match(/credit.*deferred/i))
        {
          ctrl.application.payment.credit_card.deferred = true;
        }
      }
    });
  });
}



// WEBPACK FOOTER //
// ./src/controllers/comparator/step3-ctrl-nogateway.js